<script setup lang="ts">
import { useDebug } from "./useDebug";

const { groupedState } = useDebug();
</script>

<template>
  <e-accordion>
    <e-accordion-item v-for="(props, type) in groupedState" :key="type" size="sm" :value="type">
      <e-accordion-header>{{ type }}</e-accordion-header>
      <e-accordion-content>
        <div v-for="{ key, prop } in props" :key="key" class="flex flex-col gap-4">
          <e-heading>
            <span>UID:</span> {{ prop.uid }} &nbsp; <span>Type:</span> {{ prop.type }} &nbsp; <span>Parent:</span>
            {{ prop.parent ?? "—" }}
          </e-heading>
          <table v-if="prop.props && prop.props.length > 0" class="table-auto">
            <thead>
              <tr>
                <th class="text-left">Prop</th>
                <th class="text-left">Value</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, propName) in prop.props" :key="propName">
                <td>{{ propName }}</td>
                <td>
                  {{ typeof value === "object" ? JSON.stringify(value) : value }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </e-accordion-content>
    </e-accordion-item>
  </e-accordion>
</template>

<style>
:host {
  display: contents;
}
</style>
